<template>
  <div class="main-job">


    <main>
      <header>

        <div v-if="stagingShow  || (currencyData.id && !logShowHidden) " style="display: flex;align-items: center;">
          <a-page-header @back="returnOpen('工作台')" class="job-page">
            <template slot="extra">
              <span @click="returnOpen(stagingShow ? '工作台' : '触发器')">返回</span>
            </template>
          </a-page-header>

          <h3 style="border-left: 2px solid #dcdfe6;">
            作业管理
          </h3>
        </div>

<!--        <a-button v-if="currencyData.id && !logShowHidden " style="margin-right:10px" icon="logout" @click="returnOpen('触发器')">返回触发器</a-button>-->


        <div v-else  style="display: flex;align-items: center;">
          <a-page-header @back="jobLog" v-if="logShowHidden" class="job-page">
            <template slot="extra">
              <span @click="jobLog">返回</span>
            </template>
          </a-page-header>

          <h3 :style="logShowHidden == true ? 'border-left: 2px solid #dcdfe6;' : ''">
            {{ logShowHidden == true ? "日志_"+oneData.processName : "作业管理" }}
          </h3>
        </div>


        <div class="btn-group">
          <a-button v-if="!logShowHidden && $IA('system:job:killbatch') " :disabled="this.selectedJobRowIds.length>0 ? false:true"  style="margin-right: 15px;"  @click="batchOpen(2)">
            <i class="table-batchTermination"></i>
            批量终止
          </a-button>
          <a-button  v-if="!logShowHidden && $IA('system:job:stopbatch') "  :disabled="this.selectedJobRowIds.length>0 ? false:true" @click="batchOpen(1)">
            <i class="table-batchStop"></i>
            批量停止
          </a-button>
          <a-popconfirm
              title="导出的表格数据量最大支持5000，确定要导出吗？"
              ok-text="确定"
              cancel-text="取消"
              :disabled="jobExportDis"
              @confirm="exportQuery('作业管理')"
          >
            <a-button  icon="download"  style="margin:0 15px"  v-if="!logShowHidden"  :disabled="jobExportDis">导出</a-button>
          </a-popconfirm>

          <a-popconfirm
              title="导出的表格数据量最大支持5000，确定要导出吗？"
              ok-text="确定"
              cancel-text="取消"
              :disabled="logExportDis"
              @confirm="exportQuery('作业日志')"
          >
            <a-button  icon="download"  style="margin-right:15px;"  v-if="logShowHidden" :disabled="logExportDis" class="logExport">导出</a-button>
          </a-popconfirm>
          <a-button v-if="$IA('system:job:start') && !logShowHidden" type="primary" icon="caret-right" @click="addJobOpen('启动作业', '')" style="margin-right: 0px;">启动作业</a-button>
        </div>


        <!-- <span>/
          {{
          logShowHidden == true ? "job log management" : "job management"
          }}</span> -->
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText"  v-if="logShowHidden">


            <a-input-search v-model.trim="pagination.searchText" placeholder="消息"
                            style="width: 200px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchTextChange" />
          </a-form-model-item>
          <a-form-model-item prop="jobKey" v-if="!logShowHidden">
            <a-input-search v-model.trim="pagination.jobKey" placeholder="作业编号"
                            style="width: 180px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchTextChange" />
          </a-form-model-item>

          <a-form-model-item  v-if="!logShowHidden">
            <a-tooltip placement="bottom" :autoAdjustOverflow="true" :trigger="['click']" overlayClassName="placeholder_tooltip" >
              <template slot="title">
                <a-form-model-item prop="robotName" v-if="!logShowHidden"   style="margin: 6px 0 5px;">
                  <a-input-search v-model.trim="pagination.robotName" placeholder="机器人"
                                  style="width: 180px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                                  @search="searchTextChange" />
                </a-form-model-item>
                <a-form-model-item prop="processName" v-if="!logShowHidden"  style="margin: 10px 0;">
                  <a-input-search v-model.trim="pagination.processName" placeholder="流程"
                                  style="width: 180px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                                  @search="searchTextChange" />
                </a-form-model-item>
                <a-form-model-item prop="environmentName" v-if="!logShowHidden"  style="margin: 10px 0;">
                  <a-input-search v-model.trim="pagination.environmentName" placeholder="环境"
                                  style="width: 180px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                                  @search="searchTextChange" />
                </a-form-model-item>
                <a-form-model-item prop="scheduleName" v-if="!logShowHidden"  style="margin: 5px 0 7px;">
                  <a-input-search v-model.trim="pagination.scheduleName" placeholder="触发器"
                                  style="width: 180px;" allow-clear :loading="btnLoad" @input="searchTextChange"
                                  @search="searchTextChange" />
                </a-form-model-item>
                <a-form-model-item prop="state" v-if="!logShowHidden" style="margin-bottom: 0px;">
                  <a-select
                      placeholder="状态"
                      allowClear
                      v-model="pagination.state"
                      mode="multiple"
                      style="width: 180px;"
                      :maxTagCount="1"
                      :loading="btnLoad"
                      @change="searchChange"

                  >
                    <a-select-option v-for="(v, k) in this.stateName" :key="k" :value="Number(k)" >{{ v }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </template>
              <a-icon type="plus-circle"  style="cursor: pointer;font-size: 16px"/>
            </a-tooltip>
          </a-form-model-item>
          <a-form-model-item prop="way" v-if="!logShowHidden" >
            <a-select placeholder="启动方式" allowClear v-model="pagination.way" style="width: 180px;" :loading="btnLoad"
                      @change="searchChange">
              <a-select-option :value="1">手动</a-select-option>
              <a-select-option :value="2">API</a-select-option>
              <a-select-option :value="3">触发器</a-select-option>
              <a-select-option :value="4">代理</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="priority" v-if="!logShowHidden">
            <a-select placeholder="作业优先级" v-model="pagination.priority" style="width: 180px;" :loading="btnLoad"
                      allow-clear @change="priorityChange">
              <a-select-option :value="0">低</a-select-option>
              <a-select-option :value="1">中</a-select-option>
              <a-select-option :value="2">高</a-select-option>
            </a-select>
          </a-form-model-item>


          <a-form-model-item prop="logLevel" v-if="logShowHidden ">
            <a-select placeholder="日志级别" v-model="pagination.logLevel" style="width: 180px;" :loading="btnLoad"
                      allow-clear @change="priorityChange">
              <a-select-option value="1">消息</a-select-option>
              <a-select-option value="2">警告</a-select-option>
              <a-select-option value="3">错误</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="orgId" v-if="!logShowHidden"   >
            <a-tree-select allowClear v-model='pagination.orgId'
                           show-search
                           :filterTreeNode="filter_tree_node"
                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="treeData" placeholder="选择部门"
                           style="width: 180px;" @change="searchChange" tree-default-expand-all
                           :replaceFields="{ title: 'name', key: 'id', value: 'id' }">
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="time" >
            <a-range-picker v-if="!logShowHidden" :value="pagination.time" v-model="pagination.time"
                            :placeholder="['创建时间: 开始', '创建时间: 结束']"   valueFormat="YYYY-MM-DD" style="width: 250px;" @change="searchChange" />
          </a-form-model-item>
          <a-form-model-item prop="startTime" >
            <a-range-picker v-if="!logShowHidden" :value="pagination.startTime" v-model="pagination.startTime"
                            :placeholder="['开始时间: 开始', '开始时间: 结束']"   valueFormat="YYYY-MM-DD" style="width: 250px;" @change="searchChange" />
          </a-form-model-item>
          <a-form-model-item >
            <a-button  v-if="!logShowHidden" @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table v-if="!logShowHidden" bordered :columns="tableColumns" :data-source="tableData" :pagination="queryCondition"
        :loading="tableLoad" rowKey="id"    :rowSelection='rowJobSelection'  @change="handleTableChange" :scroll="{ y: 560 }">
        <template slot="scheSourceType" slot-scope="text">
                <span v-if="text === 1">
                  <a-tag color="blue">手动</a-tag>
                </span>
          <span v-if="text === 2">
                  <a-tag color="cyan">API</a-tag>
                </span>
          <span v-if="text === 3">
                  <a-tag color="orange">触发器</a-tag>
                </span>
          <span v-if="text === 4">
                  <a-tag color="pink">代理</a-tag>
                </span>
        </template>
        <template slot="state" slot-scope="text">
          <img class="img-lc" :src="deviceStateIcon[text]" alt="" />
          {{ stateName[text] }}
        </template>
        <template slot="priority" slot-scope="text">
          <img class="img-lc" :src="priorityIcon[text]" alt="" />
          <span>
            {{ priorityName[text]  }}
          </span>
        </template>
        <template slot="logInfo" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span>{{ text ? text.slice(0, 10) : '' }}</span>
          </a-tooltip>
        </template>
        <span slot="action" slot-scope="record" class="table-action-box" style="justify-content: center;align-items: center;">
            <a-tooltip  content="" placement="top" effect="light">
               <template slot="title">
                 <span>重新执行</span>
               </template>
             <i v-if="[2, 3, 6].includes(record.state) && $IA('system:job:restart') " @click="addJobOpen('重新执行', record)"
              class="table-action ant-execute-icon" />
            </a-tooltip>

             <a-tooltip  content="" placement="top" effect="light" >
               <template slot="title">
                 <span>终止</span>
               </template>
             <i v-if="  [0, 1, 4].includes(record.state) &&  record.robotType != 1 &&$IA('system:job:kill')"  @click="handleOpen('终止', record)" class="table-action ant-cease-icon" />
            </a-tooltip>

              <a-tooltip  content="" placement="top" effect="light" v-if="$IA('system:job:kill')">
               <template slot="title">
                 <span>停止</span>
               </template>
              <i v-if="  [0, 1].includes(record.state) &&  record.robotType != 1 && record.shouldStop === 0 &&$IA('system:job:stop') "  type="close-circle" @click="handleOpen('停止', record)" class="table-action ant-termination-icon" />
            </a-tooltip>


          <a-dropdown placement="topRight" :trigger="['click']">
            <i class="ant-dropdown-link table-action ant-dropdown-icon" />
            <a-menu slot="overlay">
              <a-menu-item v-if="$IA('system:job:viewLog')" @click="examineLog('查看', record)">
                 <i class="table-view action_icon" ></i>
                <span>作业日志</span>
              </a-menu-item>
              <a-menu-item v-if="$IA('system:jobLog:findPage')" @click="detailsOpen(record)">
                  <i class="table-assignmentDetails action_icon" ></i>
                <span>作业详情</span>
              </a-menu-item>
              <a-menu-item v-if="record.screenRecord == 1 && record.screenRecord  != null && $IA('system:job:video')"  @click="viewRecording(record)" >
                <a-icon type="video-camera" /><span>查看录屏</span>
              </a-menu-item>
              <a-menu-item v-if="$IA('system:job:picture')"  @click="viewpicture(record)" >
                <i class="table-viewPicture action_icon"></i><span>查看图片</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 日志表格 -->
      <a-table v-if="logShowHidden" :columns="logColumns" :data-source="logData" :pagination="jurnalCondition"
        :loading="journalLoad" @change="journalTableChange" :scroll="{ y: 560 }">
        <template slot="logLevel" slot-scope="text">
          {{ logLevelDict[text] }}
        </template>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle + '作业'" :visible="modalVisible" :confirm-loading="btnLoad" @ok="terminationJob()"
      @cancel="jobResetForm" :footer="modalTitle == '查看' ? null : undefined" :confirmLoading="submitLoad"  :maskClosable="false">
      <a-alert v-if="['停止','终止'].includes(modalTitle)" message="确定继续吗？" :description="modalTitle == '终止' ? '* 此操作将终止该作业.' : '* 此操作将停止该作业.'" type="warning" show-icon />
    </a-modal>

    <!-- 启动流程 -->
    <a-modal centered :title="modalTitle" :visible="startUpJobVisible" @cancel="resetForm" :confirm-loading="submitLoad"
      @ok="startUpSubmit" width="700px" class="ant-start-modal" destroyOnClose  :maskClosable="false"  >
      <i class="ant-start-underline"></i>
      <a-form-model :rules="startUpRules" :model="startUpForm" ref="startUpForm">
        <a-row :gutter="23">


        <div>
          <a-col :span="16" v-if="modalTitle == '启动作业'">
            <a-form-model-item label="部门" prop="orgId" >
              <a-tree-select
                  v-model='startUpForm.orgId'
                  show-search
                  :filterTreeNode="filter_tree_node"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="treeData" @change="treeChange"
                placeholder="选择部门" tree-default-expand-all :replaceFields="{ title: 'name', key: 'id', value: 'id' }">
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="16" v-else>
            <a-form-model-item label="部门" prop="orgName"  >
              <a-input v-model="startUpForm.orgName" disabled />
          </a-form-model-item>
          </a-col>
        </div>

          <a-col :span="8">
            <a-form-model-item label="是否录屏" prop="screenRecord"  >
              <a-switch v-model="startUpForm.screenRecord" checked-children="开" un-checked-children="关" :checked="startUpForm.screenRecord == 1 ? true : false "   />
            </a-form-model-item>
          </a-col>

        <div>
          <a-col :span="16"  v-if="modalTitle == '启动作业'">
            <a-form-model-item label="流程" prop="processId">
              <a-select :disabled="modalTitle == '重新执行'" v-model="startUpForm.processId" show-search
                :filter-option="filterOption" placeholder="请选择" @change="taskChange">
                <a-select-option :key="item.id" v-for="item in this.taskList" :value="item.id" :label="item.name">{{
                  item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="16" v-else>
            <a-form-model-item label="流程" prop="processName"  >
              <a-input v-model="startUpForm.processName" disabled />
          </a-form-model-item>
          </a-col>
        </div>

          <a-col :span="8">
            <a-form-model-item label="作业优先级" prop="priority">
              <a-select v-model="startUpForm.priority" placeholder="请选择">
                <a-select-option v-for="(v, index) in priorityName" :key="index" :value="Number(index)">
                  <img :src="priorityIcon[index]" style="margin-top: -5px" />
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="执行设备">
                <a-col :span="24">
                  <a-form-model-item prop="type" style="border-bottom: 1px solid #c7c7c7;margin:-10px 0 20px;">
                    <a-radio-group v-model="startUpForm.type">
                      <a-radio :value="1">特定机器人</a-radio>
                      <a-radio :value="2">动态分配</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="startUpForm.type == 1">

                  <a-form-model :model="robotCondition" ref="searchRobotBar" :layout="formLayout" style="margin: 0px 0 15px;">
                    <a-form-model-item prop="searchText">
                      <a-input-search v-model.trim="robotCondition.searchText" placeholder="机器人/计算机"
                                      style="width: 200px;margin-top: 2px; " allow-clear    @input="searchRobotTextChange" @search="robotSearchChange" />
                    </a-form-model-item>
                    <a-form-model-item prop="status">
                      <a-select v-model="robotCondition.status" placeholder="状态" style="width: 180px; "
                                allowClear @change="robotSearchChange">
                        <a-select-option :value="0">可用</a-select-option>
                        <a-select-option :value="1">断开连接</a-select-option>
                        <a-select-option :value="2">忙碌</a-select-option>
                        <a-select-option :value="3">无响应</a-select-option>
                      </a-select>
                    </a-form-model-item>

                    <a-form-model-item style="float: right;margin-right: 0px;">
                      <a-button @click="resetRobotSearch" size="small"  style="width: 74px">重 置</a-button>
                    </a-form-model-item>
                  </a-form-model>


                  <a-table :columns="robotColumns" :data-source="robotData"
                    width="400px" rowKey="id"   :loading="robotTableLoad" :pagination="robotCondition" @change="robotTableChange" :rowSelection="{
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }" :scroll="{ y: 190 }">
                    <template slot="name" slot-scope="text, record">
                      <img :src="statsIcon[record.status]" />
                      <span> {{ text }}</span>
                    </template>
                    <template slot="status" slot-scope="text">
                      <span> {{ statusName[text] }}</span>
                    </template>
                  </a-table>
                </a-col>
                <a-col :span="15" v-if="startUpForm.type == 2">
                  <a-form-model-item label="执行流程次数" prop="executeCount">
                    <a-input-number placeholder="请输入" style="width: 100%" v-model="startUpForm.executeCount" :min="1"
                      :max="999" />
                  </a-form-model-item>
                </a-col>

              </a-tab-pane>
              <a-tab-pane key="2" tab="附加参数"  force-render>
                <a-col :span="24">
                  <a-table :columns="parameterColumns" :data-source="startUpForm.parameter" :loading="btnLoad"
                    :pagination="false" :scroll="{ y: 140 }">

                    <template slot="argName" slot-scope="text, record, index">
                      <span>{{ text }}  <span style="color: red" v-if="record.required == 1">*</span> </span>
                    </template>
                    <template slot="defaultValue" slot-scope="text, record, index">

                      <a-form-model-item :prop="'parameter.' + index + '.defaultValue'"
                        :rules="{ required: record.required == 1 , message: '请输入参数值', trigger: 'blur' }">
                        <a-input-number v-model="record.defaultValue" placeholder="请输入" :min="1" :max="999"
                          v-if="record.argType === 1" style="width: 100%" />
                        <a-input v-model="record.defaultValue" placeholder="请输入"
                          v-if="record.argType === 2 || record.argType === 4" />
                        <a-select v-model="record.defaultValue" placeholder="请输入" v-if="record.argType === 3">
                          <a-select-option value="true">是</a-select-option>
                          <a-select-option value="false">否</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table>
                </a-col>
              </a-tab-pane>
            </a-tabs>
          </a-col>

        </a-row>
      </a-form-model>
    </a-modal>

    <!-- 查看作业详情 -->

    <a-modal centered title="作业详情" :visible="detailsVisible" @cancel="detailsVisible = false"  :maskClosable="false">
      <a-descriptions bordered   class="job-details" :column="1" size="small">
        <a-descriptions-item label="作业编号">{{ this.singleDta.jobKey }}</a-descriptions-item>
        <a-descriptions-item label="流程">{{ this.singleDta.processName }}</a-descriptions-item>
        <a-descriptions-item label="环境">{{ this.singleDta.environmentName }}</a-descriptions-item>
        <a-descriptions-item label="机器人名称">{{ this.singleDta.robotName }}</a-descriptions-item>
        <a-descriptions-item label="计算机名称">{{ this.singleDta.machineName }}</a-descriptions-item>
        <a-descriptions-item label="信息" >
          <a-tooltip  placement="topLeft">
            <template slot="title">
          {{    this.singleDta.logInfo}}
            </template>
           <span class="details">
               {{ this.singleDta.logInfo }}
           </span>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item label="创建人">{{ this.singleDta.userName }}</a-descriptions-item>
        <a-descriptions-item label="开始时间">{{ this.singleDta.beginTime }}</a-descriptions-item>
        <a-descriptions-item label="结束时间">{{ this.singleDta.endTime }}</a-descriptions-item>
        <a-descriptions-item label="是否录屏">{{  screenRecordLable(this.singleDta)}}</a-descriptions-item>
        <a-descriptions-item label="输入值">{{ this.singleDta.inputParams }}</a-descriptions-item>
        <a-descriptions-item label="输出值">{{ this.singleDta.outputParams }}</a-descriptions-item>
      </a-descriptions>
      <template slot="footer">
        <a-button key="back" @click="detailsVisible = false">
          关闭
        </a-button>

      </template>
    </a-modal>

    <a-modal centered title="查看录屏" width="820px" class="a-model-class"  :visible="recordingVisible" @cancel="videoClose" :maskClosable="false">


      <div v-for="v in videoData" :key="v.id" class="video-box" v-if="videoShiw && videoData">
        <p>{{ v.createTime }}</p>
        <video controls width="100%" height="300px" >
          <source :src="pathUrl+ v.fstorage" type="video/webm"/>
        </video>
      </div>


       <div class="default_img" v-if="!(videoShiw && videoData)">
         <div class="nothing-data">
         </div>
         <p>暂无数据</p>
       </div>


      <template slot="footer">
        <a-button  @click="videoClose">
          关闭
        </a-button>
      </template>
    </a-modal>


    <!-- 提示框 -->
    <a-modal :visible="messageVisible" width="450px" :closable="false" @cancel="messageVisible = false" class="message-modal" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="messageVisible = false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="submitLoad" @click="submitClick">
          确定
        </a-button>
      </template>
      <p style="padding:40px 20px 20px;margin-bottom:0px;font-weight:600;font-size: 16px;"><a-icon type="question-circle" style="color:#fa7900;margin-right:10px;font-size:18px" />{{batchText}}</p>
    </a-modal>


    <!-- 查看图片-->
    <a-modal centered title="查看图片" width="650px" :visible="pictureVisible" @cancel="pictureClose"  :maskClosable="false">
      <a-form-model :model="picturePagination" ref="pictureSearchBar" :layout="formLayout" style="margin-bottom: 20px;">
        <a-form-model-item prop="description" >
          <a-input-search placeholder="描述" style="width: 200px;" :loading="btnLoad"
                          allowClear v-model.trim="picturePagination.description"  @search="pictureSearchChange" @input="pictureSearchTextChange" />
        </a-form-model-item>
      </a-form-model>

      <a-table :columns="pictureColumns"   :data-source="pictureData" :pagination="false"
               :loading="pictureLoad" :scroll="{ y: 260 }">
        <template slot="fstorage" slot-scope="text, record">
          <div class="previewPictures">
            <img :src=" pathUrl+ record.fstorage" class="previewPictures">
            <div class="previewPictures-operation">
              <a-icon type="plus-circle"  @click="handlePreview(pathUrl+ record.fstorage)"/>
            </div>

            <a-modal :visible="previewVisible" :footer="null" width="1200px" @cancel="previewVisible = false" class="preview-box">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </template>
      </a-table>

      <template slot="footer">
        <a-button key="back" @click="pictureClose">
          关闭
        </a-button>

      </template>
    </a-modal>

  </div>
</template>

<script>
import store from "@/store";
import {notification} from "ant-design-vue";
// 引入websocket
import useWS from "@/utils/websocket.js";
export default {
  computed: {
    store() {
      return store
    },
    rowJobSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          let keyS = []
          this.selectedJobRowIds = selectedRowKeys;
          selectedRows.forEach((item)=>{
            keyS.push(item.jobKey)
          })
          this.selectedJobRowKeys = keyS
        },
        getCheckboxProps: record => ({
          props: {
            disabled:[2,3,4,6].includes(record.state), // Column configuration not to be checked
          },
        }),
        selectedRowKeys: this.selectedJobRowIds,
      };
    },
  },
  props: ['currencyData'],
  data() {
    return {
      logShowHidden: false,
      robotTableLoad: false,
      btnLoad: false,
      tableLoad: false,
      journalLoad: false,
      // 是否按钮loading
      submitLoad: false,
      pagination: {
        scheduleId: "",
        searchText: "",

        robotName: "",
        processName: "",
        environmentName: "",
        scheduleName: "",
        jobKey:"",

        way: undefined,
        state: [],
        priority: undefined,
        logLevel: undefined,
        time: [],
        startTime:[],
        pageSize: 10,
        orgId:undefined,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      journalPagination: {
        searchText: "",
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        logLevel: undefined,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `,
        jobId: "",
      },
      formLayout: "inline",
      queryCondition: {},
      jurnalCondition: {},
      robotCondition:{
        searchText: "",
        status:undefined,
        current: 1,
        pageSize: 5,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showTotal: (total, range) => `共 ${total} 条记录  `,
        processId: "",
      },
      logColumns: [
        {
          title: "时间",
          dataIndex: "createTime",
          key: "createTime",
        },
        {
          title: "级别",
          dataIndex: "logLevel",
          key: "logLevel",
          scopedSlots: { customRender: "logLevel" },
          ellipsis: true,
        },
        {
          title: "流程",
          dataIndex: "processName",
          key: "processName",
          ellipsis: true,
        },
        {
          title: "消息",
          dataIndex: "msg",
          key: "msg",
          ellipsis: true,
        },
      ],
      logData: [],
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "作业编号",
          dataIndex: "jobKey",
          key: "jobKey",
          ellipsis: true,
        },
        {
          title: "流程",
          dataIndex: "processName",
          key: "processName",
          ellipsis: true,
        },

        {
          title: "机器人",
          dataIndex: "robotName",
          key: "robotName",
          ellipsis: true,
        },
        {
          title: "环境",
          key: "environmentName",
          dataIndex: "environmentName",
          ellipsis: true,
        },
        {
          title: "部门",
          ellipsis: true,
          dataIndex: "orgName",
          key: "orgName",
        },
        {
          title: "状态",
          key: "state",
          dataIndex: "state",
          ellipsis: true,
          scopedSlots: { customRender: "state" },
        },
        {
          title: "作业优先级",
          key: "priority",
          ellipsis: true,
          dataIndex: "priority",
          scopedSlots: { customRender: "priority" },
        },
        {
          title: "创建人",
          ellipsis: true,
          dataIndex: "userName",
          key: "userName",
        },
        {
          title: "创建时间",
          key: "createTime",
          ellipsis: true,
          dataIndex: "createTime",
        },
        {
          title: "开始时间",
          key: "beginTime",
          ellipsis: true,
          dataIndex: "beginTime",
        },
        {
          title: "结束时间",
          key: "endTime",
          ellipsis: true,
          dataIndex: "endTime",
        },
        {
          title: "启动方式",
          key: "scheSourceType",
          scopedSlots: { customRender: "scheSourceType" },
          dataIndex: "scheSourceType",
          width: 100,
          ellipsis: true,
        },
        {
          title: "触发器",
          dataIndex: "scheduleName",
          key: "scheduleName",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 130,
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 查看详情
      detailsVisible: false,
      // 单行数据
      oneData:'',
      singleDta: "",
      // 流程下拉数据
      taskList: [],
      stateName: {
        0: "等待",
        1: "执行中",
        2: "成功",
        3: "失败",
        4: "停止中",
        5: "终止中",
        6: "已停止",
      },
      deviceStateIcon: {
        0: require("../assets/images/pending_img.png"),
        1: require("../assets/images/executing_img.png"),
        2: require("../assets/images/complete_img.png"),
        3: require("../assets/images/fail_img.png"),
        4: require("../assets/images/terminated_img.png"),
        5: require("../assets/images/stopping_img.png"),
        6: require("../assets/images/stopped_img.png"),
      },
      logLevelDict: {
        1: "消息",
        2: "警告",
        3: "错误",
      },
      // 启动作业
      startUpJobVisible: false,
      startUpRules: {
        processId: [{ required: true, message: "流程不能为空" }],
        priority: [{ required: true, message: "作业优先级不能为空" }],
        type: [{ required: true, message: "执行设备不能为空" }],
        screenRecord: [{ required: false, message: "是否录屏不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        executeCount: [{ required: true, message: "执行流程次数不能为空" }],
        orgName: [{ required: true, message: "部门不能为空" }],
        processName: [{ required: true, message: "流程不能为空" }],
      },
      startUpForm: {
        orgId: undefined,
        processId: undefined,
        priority: 1,
        processName:"",
        orgName:"",
        screenRecord:false,
        type: 1,
        robotIds: [],
        executeCount: 1,
        parameter: [],
      },
      singleTriggerData: {},
      selectedRowKeys: [], //复选框数据
      // 优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
        // 3: "已继承"
      },
      priorityIcon: {
        0: require("../assets/images/low.png"),
        1: require("../assets/images/normal.png"),
        2: require("../assets/images/height.png"),
        // 3: require("../assets/images/inherited.png"),
      },
      statsIcon: {
        0: require("../assets/images/newest.png"),
        1: require("../assets/images/break.png"),
        2: require("../assets/images/beBusy.png"),
      },
      statusName: {
        0: "可用",
        1: "断开连接",
        2: "忙碌",
        3: "无响应",
      },
      robotColumns: [
        {
          title: "机器人",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "计算机",
          dataIndex: "machineName",
          key: "machineName",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
      ],
      robotData: [],
      // 流程选中
      processSelection:{},
      // 附加参数
      parameterColumns: [
        {
          title: "参数名称",
          dataIndex: "argName",
          key: "argName",
          scopedSlots: { customRender: "argName" },
        },
        {
          title: "参数值",
          dataIndex: "defaultValue",
          key: "defaultValue",
          scopedSlots: { customRender: "defaultValue" },
        },
      ],
      // 分页参数
      pagCurrent: {},
      cloneForm: {},
      // 部门列表
      treeData: [],

      videoJobKey:'',
      // 录屏
      recordingVisible:false,
      // 视频url
      videoUrl:'',
      videoPlayer:'',
      videoShiw:false,
      stagingShow:false,
      videoData:[],
      //  批量操作
      selectedJobRowIds:[],   // 已选id
      selectedJobRowKeys:[],  // 已选key
      // 提示
      messageVisible:false,
      jobId:[],
      batchApi:'',
      batchText:'',
      // 导出按钮禁用显示判断
      logExportDis:false,
      jobExportDis:false,


      pictureVisible:false,
      pictureLoad:false,
      picturePagination:{
        description:'',
        current: 1,
        pageSize: 5,
        pageNo: 1,
        total: 0,
      },
      previewVisible:false,
      previewImage:'',
      pictureData:[],
      pathUrl:window.env.API_SCREEN_BASE_URL_FILE,
      pictureColumns: [
        {
          title: "时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true,
        },
        {
          title: "描述",
          dataIndex: "remark",
          key: "remark",
          ellipsis: true,
        },
        {
          title: "查看图片",
          dataIndex: "fstorage",
          key: "fstorage",
          scopedSlots: { customRender: "fstorage" },
          ellipsis: true,
        },

      ],
    };
  },
  methods: {
    screenRecordLable(data){
      if (data.screenRecord == 1){
        return '是'
      }else{
        return '否'
      }
    },

    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 开启搜索
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置表单通用方法
    jobResetForm() {
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.pagination.state = []
      if (this.logShowHidden == false) {
        this.pagination.way = undefined
        this.pagination.orgId = undefined
        this.pagination.current  = 1
        this.pagination.pageNo  = 1

        this.pagination.priority = undefined
        this.jobExportDis = false

        this.searchChange()

      } else {
        this.journalPagination.logLevel = undefined
        this.journalPagination.searchText = ''
        this.logExportDis = false
        this.searchJournlChange()
      }
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.$nextTick(() => {
        this.singleDta = data;

      })
    },
    // 导出
    exportQuery(title){
      let exportParam = {},exportApi = '';
      switch (title) {
        case '作业管理':
          exportParam = this.$lodash.cloneDeep(this.pagination)
          exportApi = '/job/export'
          exportParam.time = exportParam.time ? exportParam.time.join(',') : ''
          exportParam.startTime = exportParam.startTime ? exportParam.startTime.join(',') : ''
          break
        case '作业日志':
          exportParam = this.$lodash.cloneDeep(this.journalPagination)
          exportApi = '/jobLog/export'

          break
      }


      this.axios.post(exportApi,  exportParam, { responseType: 'blob' }).then((res)=>{
        const blob = new Blob([res], {
          type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        if (window.navigator.msSaveBlob) {          //IE兼容处理
          try {
            window.navigator.msSaveBlob(blob,'作业管理'+'.xlsx');
          } catch (e) {
            console.log(e);
          }
        } else {
          const url = window.URL.createObjectURL(blob);
          const aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", '作业管理'+'.xlsx');
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      }).catch((err)=>{
        console.log(err.message);
      })

    },
    // 批量停止
    batchOpen(val){
      this.messageVisible = true
      switch (val){
        case 1:
          this.batchText = '是否停止所选作业?'
          this.batchApi = 'job/stopBatch'
          break
        case 2:
          this.batchText = '是否终止所选作业?'
          this.batchApi = 'job/killBatch'
          break
      }
    },
    // 批量提交
    submitClick(){
      this.messageVisible = true
      this.submitLoad = true
      this.axios
          .post(this.batchApi, {ids:this.selectedJobRowIds,jobKeys:this.selectedJobRowKeys})
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagCurrent);
              this.messageVisible = false
              this.selectedJobRowIds = []
              this.selectedJobRowKeys = []
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
    },
    // 查看
    examineLog(title, data) {

      this.logShowHidden = true;
      this.stagingShow = false
      this.journalPagination.jobId = data.id;
      this.oneData = data
      this.searchJournlChange();
      this.cloneForm = this.$lodash.cloneDeep(this.pagination)
      this.pagination.searchText = "";
      this.pagination.priority = undefined;
      this.journalPagination.logLevel = undefined
    },

    // 关闭录屏弹出框
    videoClose(){
      this.videoUrl = ''
      this.videoShiw = false
      this.recordingVisible = false
    },

    // 查看录屏
    viewRecording(data){
      this.recordingVisible = true
      this.videoShiw = false
      this.axios
          .get("/job/download?jobKey=" + data.jobKey )
          .then((res) => {
            if (res.code == 200){
            this.videoShiw = true
            this.videoData = res.data
            // this.videoUrl = window.env.API_SCREEN_BASE_URL + res.data
            }
          })
          .catch((err) => {
            this.videoShiw = false
            console.log(err);
          });
    },
    pictureSearchChange(){
     this.pictureAjax(this.singleDta )
    },
    // 监听搜索输入框输入
    pictureSearchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.pictureAjax(this.singleDta )
      }, 1200);
    },
    // 查看图片
    viewpicture(data){
      this.pictureVisible = true
      this.singleDta = data
      this.pictureAjax(data)
    },
    // 关闭
    pictureClose(){
      this.pictureVisible = false
      this.picturePagination.description = ''
    },
    pictureAjax(data){
      console.log(data)
      this.axios
          .get("/job/downloadPicture?jobKey=" +data.jobKey + '&description=' + this.picturePagination.description)
          .then((res) => {
            if (res.data){
              this.pictureData = res.data
            }else{
              this.pictureData = []
            }
          })
          .catch((err) => {
            this.videoShiw = false
            console.log(err);
          });
    },
    // 图片放大
    handlePreview(img){
      this.previewImage = img;
      this.previewVisible = true;
    },
    // 终止作业
    terminationJob() {
      this.submitLoad = true;
      this.axios
        .post(this.modalTitle == '停止' ? '/job/stop' : '/job/kill', {id:this.singleDta.id,processName:this.singleDta.processName,jobKey:this.singleDta.jobKey})
        .then((res) => {
          this.submitLoad = false;
          if (res.code === 200) {
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
            this.modalVisible = false;
            this.tableAjax()
          }
          this.handleTableChange(this.pagination);
          this.modalVisible = false;
        })
        .catch((err) => {
          this.submitLoad = false;
          console.log(err);
        });
    },
    // switch开关转换
    switchChange(val){
      if (val){
        this.startUpForm.screenRecord = 1
      }else{
        this.startUpForm.screenRecord = 0
      }
    },
    // 返回
    jobLog() {
      this.logShowHidden = false;
      this.logExportDis = false
      this.pagination.searchText = "";
      this.pagination = this.queryCondition
      this.pagination.time = typeof(this.queryCondition.time)   == "string"  ? this.queryCondition.time.split(',') : this.queryCondition.time
      this.pagination.startTime = typeof(this.queryCondition.startTime)   == "string"  ?  this.queryCondition.startTime.split(',') :  this.queryCondition.startTime

      this.journalPagination.logLevel = undefined
      this.handleTableChange(this.pagCurrent);
    },
    // 重置表单通用方法
    resetForm() {
      this.$refs.startUpForm.resetFields()
      this.robotCondition.processId = undefined
      this.startUpJobVisible = false
    },
    // 添加启动作业
    addJobOpen(title, data) {
      switch (title) {
        case '启动作业':
          this.selectedRowKeys = [];
          this.startUpForm.processId = undefined
          this.startUpForm.orgId = undefined
          this.robotData = []
          this.startUpForm.parameter = []
          this.treeChange(this.startUpForm.orgId)
          break;
        case '重新执行':
          this.startUpForm.orgId = data.orgId
          this.startUpForm.orgName = data.orgName
          this.startUpForm.priority = data.priority
          this.startUpForm.processId = data.processId
          // this.taskChange(data.processId)
          this.startUpForm.parameter = data.parameter
              ? JSON.parse(data.parameter)
              : "";
          this.againTaskList(data.processId)
          // this.selectedRowKeys =  data.robotId   ? data.robotId.split(",") : [];
          this.startUpForm.robotIds = this.selectedRowKeys
          this.robotCondition.processId =  data.processId
          this.singleTriggerData = data
          break;
      }


      this.robotCondition.status = undefined
      this.robotCondition.searchText = ''
      this.robotCondition.current = 1
      this.robotCondition.pageSize = 5
      this.robotCondition.total = 0

      this.modalTitle = title
      this.startUpJobVisible = true
    },
    // 重新执行流程下拉框
    againTaskList(id) {
      this.axios
        .post("/process/getById", this.$qs.stringify({id}))
        .then((res) => {
          if (res.code === 200) {
            this.startUpForm.processName = res.data.name
            this.startUpForm.processId = res.data.id
            // this.parameterList(res.data)
            // this.allRobotList(res.data);
            this.robotTableChange('','','',res.data)
            this.processSelection = res.data
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听部门
    treeChange(val) {
      this.startUpForm.processId = undefined
      this.startUpForm.parameter = []
      this.robotData = []
      this.axios
        .post("/process/findProcess", { orgId: val })
        .then((res) => {
          if (res.code === 200) {
            this.taskList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听流程下拉框-选择机器人
    taskChange(val) {
      this.axios
        .post("/process/findProcess", { orgId: this.startUpForm.orgId })
        .then((res) => {
          if (res.code === 200) {
            this.taskList = res.data;
            this.taskList.forEach((v) => {
              if (val === v.id) {
                // 附加参数
                this.parameterList(v)
                // this.allRobotList(v);
                this.robotCondition.processId = v.id
                this.robotTableChange('','','',v)
              }
            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.startUpForm.robotIds = undefined;
      this.selectedRowKeys = []
    },
    // 附加参数列表
    parameterList(data) {
      this.axios
        .post(
          "/process/findProcessArgsByProcess",
          "versionId=" + data.versionId + "&processId=" + data.id
        )
        .then((res) => {
          if (res.code === 200) {
            this.startUpForm.parameter = res.data;
            for (let i = 0; i < this.startUpForm.parameter.length; i++) {
              if (this.startUpForm.parameter[i].defaultValue) {
                this.startUpForm.parameter[i].defaultValue = undefined;
              }else{
                this.startUpForm.parameter[i].defaultValue = undefined;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 特定机器人列表
    allRobotList(data) {
      // this.robotCondition.processId = data ?  data.id :this.processSelection.id
      this.robotTableLoad = true
      this.axios
        .post(
          "/robot/findRobotsByProcessId",
            this.robotCondition
        )
        .then((res) => {
          this.robotTableLoad = false
          // console.log(res.data);
          if (res.code === 200) {
            this.robotData = res.data.records;
            this.robotCondition.total = res.data.total;

            this.selectedRowKeys = this.singleTriggerData.robotIds
                ? this.singleTriggerData.robotIds.split(",")
                : [];
          }
        })
        .catch((err) => {
          this.robotTableLoad = false
          console.log(err);
        });
    },
    // 提交启动作业
    startUpSubmit() {
      this.$refs.startUpForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let saveData = "";
          saveData = this.$lodash.cloneDeep(this.startUpForm);
          saveData.parameter = saveData.parameter
            ? JSON.stringify(saveData.parameter)
            : '';
          if (!saveData.screenRecord ){
            saveData.screenRecord = 0
          }else{
            saveData.screenRecord = 1
          }
          saveData.robotIds = saveData.robotIds ? saveData.robotIds.join(",") : "";
          this.axios
            .post("/job/save", saveData)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                this.$refs.startUpForm.resetFields()
                this.startUpJobVisible = false;
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagination);
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
        }else{
          this.$message.warning('请检查必填项(含附加参数)是否全部填写完成');
        }
      });
    },

    // 监听表格复选
    onSelectChange(selectedRowKeys, selectedRows) {
      let obj = [];
      selectedRows.forEach((element) => {
        obj.push(element.id);
      });
      this.startUpForm.robotIds = obj;
      this.selectedRowKeys = selectedRowKeys;
    },

    // 监听搜索
    priorityChange(v) {
      if (this.logShowHidden == false) {
        this.searchChange()
      } else {
        this.journalPagination.logLevel = v
        this.searchJournlChange(v)
      }
    },

    // 打开作业详情
    detailsOpen(data) {
      this.detailsVisible = true
      this.axios
        .post("/job/findDetail", {id:data.id})
        .then((res) => {
          this.singleDta = res.data
             for(let v in this.singleDta){
               if (this.singleDta[v] == null ) {
                this.singleDta[v] = '--'
               }
             }
        })
        .catch((err) => {
          console.log(err);
        });

    },

    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      // this.queryCondition.state = this.queryCondition.state ? this.queryCondition.state.join(',') : []
      this.queryCondition.time = this.queryCondition.time ? this.queryCondition.time.join(',') : ''
      this.queryCondition.startTime = this.queryCondition.startTime ? this.queryCondition.startTime.join(',') : ''
      this.queryCondition.scheduleId = this.currencyData.id ? this.currencyData.id : ''
      this.tableAjax()
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        if (this.logShowHidden == false) {
          this.searchChange(val)
        } else {
          this.journalPagination.searchText = val.srcElement._value
          this.searchJournlChange(val)
        }
      }, 1200);
    },
    // 重置搜索
    resetRobotSearch() {
      this.$refs.searchRobotBar.resetFields()
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.robotSearchChange()
    },
    searchRobotTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.robotSearchChange(val)
      }, 1200);
    },
    // 搜索
    robotSearchChange(v) {
      this.robotCondition = this.$lodash.cloneDeep(this.robotCondition)
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.allRobotList()
    },
    // 监听分配机器表格翻页
    robotTableChange(pagination, filters, sorter,data) {
      this.robotCondition.pageNo = pagination.current ? pagination.current : 1
      this.robotCondition.current = pagination.current ? pagination.current : 1
      this.robotCondition.pageSize = pagination.pageSize ? pagination.pageSize : 5
      // this.selectedRowKeys = []
      // this.startUpForm.robotIds = undefined
      this.allRobotList('','','',data)
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo = pagination.current ? pagination.current : 1
      this.queryCondition.current = pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10

      this.pagCurrent = pagination ? pagination : this.pagination

      this.tableAjax()
    },

    // 翻页请求
    tableAjax() {
      let searchData = {};

      searchData =  this.$lodash.cloneDeep(this.queryCondition)
      searchData.time =  typeof(searchData.time)   == "string"  ? searchData.time : searchData.time.join(',')
      searchData.startTime =  typeof(searchData.startTime)   == "string"  ? searchData.startTime : searchData.startTime.join(',')
      this.tableLoad = true;
      this.axios
        .post("/job/findPage", searchData)
        .then((res) => {
          this.tableLoad = false;
          this.tableData = res.data.records;
          this.queryCondition.total = res.data.total;
          if (this.tableData.length  == 0){
            this.jobExportDis = true
          }else{
            this.jobExportDis = false
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
    // 搜索
    searchJournlChange(v) {
      this.jurnalCondition = this.$lodash.cloneDeep(this.journalPagination)
      if (v == undefined) {
        this.pagination.searchText = "";
      } else {
        this.jurnalCondition.priority = this.pagination.priority
      }
      this.journalTableAjax()
    },
    // 监听翻页
    journalTableChange(pagination, filters, sorter) {
      this.jurnalCondition.pageNo = pagination.current ? pagination.current : 1
      this.jurnalCondition.current = pagination.current ? pagination.current : 1
      this.jurnalCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.journalTableAjax()
    },
    // 作业日志管理请求
    journalTableAjax() {
      this.journalLoad = true;
      this.axios
        .post(
          "/jobLog/findPage",
          this.$qs.stringify(this.jurnalCondition)
        )
        .then((res) => {
          this.journalLoad = false;
          this.logData = res.data.records;
          this.jurnalCondition.total = res.data.total;
          if (this.logData.length  == 0){
            this.logExportDis = true
          }
        })
        .catch((err) => {
          console.log(err);
          this.journalLoad = false;
        });
    },
    // 返回
    returnOpen(title) {
      switch (title) {
        case '工作台' :
          this.$emit("close", '工作台');
              break
        case '触发器' :
          this.$emit("close", '触发器');
              break
      }
    },
    // 通知表格刷新
    handleJobWS(type,data){
      this.tableData.forEach((item)=>{
        if (item.id == data.id){
            item.state = data.state
            item.beginTime = data.beginTime
            item.endTime = data.endTime
        }
      })
    }
  },
  beforeMount() {
    switch (this.currencyData) {
      case '1':
        this.pagination.state = [0]
        this.stagingShow = true
        break
      case '2' :
        this.pagination.state = [1]
        this.stagingShow = true
        break
      case '3' :
        this.pagination.state = [2,3,6]
        this.stagingShow = true
        break
    }
    this.searchChange();
    this.allorgList()
  },
  mounted() {
    useWS('JOB', '/admin/websocket/job:jobState', this.handleJobWS)
  }
};
</script>

<style lang="scss" scoped>
.main-job {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;


      h3 {
        margin-bottom: -3px;
        line-height:16px;
        padding-left: 12px;
        border-left: 4px solid #3373f2;
        font-size: 18px;
        //font-weight: bold;
      }

      span {
        line-height: 16px;
        //margin-left: 10px;
        color: #808080;
      }

      .job-page {
        height: 0;
        padding: 0px;
        margin-bottom: 20px;
      }

      .btn-group{
        ::v-deep .ant-btn:nth-child(1){
          i{
            //color: red;
          }
        }
        ::v-deep .ant-btn:nth-child(2){
          i{
            color: red;
          }
        }
        ::v-deep .ant-btn[disabled]:nth-child(1){
          i{
            color: #bdbdbd;
          }
        }
        ::v-deep .ant-btn[disabled]:nth-child(2){
          i{
            color: #bdbdbd;
          }
        }

        .logExport{
         ::v-deep i{
            color: #6a768f !important;
          }
        }


        i{
          padding: 0px 0px 0px 0px;
          margin-right: 10px;
        }

        .ant-btn:last-child{
          margin-right: 0px;
        }


        .ant-btn[disabled]{
          i.table-batchStop { background-image: url('../assets/images/icon_btn/icon_batchStop_disabled.png'); }
          i.table-batchTermination { background-image: url('../assets/images/icon_btn/icon_batchTermination_disabled.png'); }
        }

      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;
          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    i.ant-execute-icon {
      background: url("../assets/images/job_execute.png") no-repeat center;
    }

    i.ant-cease-icon {
      background: url("../assets/images/job_cease.png") no-repeat center;
    }
    i.ant-termination-icon {
      background: url("../assets/images/job_termination.png") no-repeat center;
    }
    i.ant-dropdown-icon {
      background: url("../assets/images/Table_action.png") no-repeat center;
    }

    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      border-radius: 20px;
      vertical-align: top;
      padding:0px ;

      &:active {
        background-color: #d8e6ff;
      }
    }

    .ant-table-wrapper {
      .ant-table-tbody {
        .img-lc {
          vertical-align: middle;
          margin-right: 6px;
          margin-top: -4px;
        }


      }
    }
  }
}



::v-deep .ant-page-header-back {
  margin: 2px 0;
  margin-right: 16px;
  .ant-page-header-back-button{
    color: #6a768f;
  }
}
::v-deep .ant-page-header-heading{
  display: flex;
  align-items: center;
 .ant-page-header-heading-extra {
    span {
      display: block;
      float: left;
      margin-bottom: 0;
      padding-right: 12px;
      color: #6a768f !important;
      line-height: 23px !important;
      margin-left: -5px !important;
      cursor: pointer;
      font-size: 16px;
    }

    span:hover {
      color: #40a9ff !important;
    }
  }
}


.ant-start-modal {
  ::v-deep .ant-modal {
    .ant-modal-body {

      .ant-form-item {

        // 下拉框激活状态颜色
        .ant-select-open .ant-select-selection {
          border-color: #fff;
          border-bottom-color: #40a9ff;
        }

        // 边框线颜色
        .ant-select-selection {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #c7c7c7;
        }

        // 下拉框阴影
        .ant-select-selection--single {
          box-shadow: none;
        }

        // 下拉框hover效果
        .ant-select-selection:hover {
          border-color: #fff;
          border-bottom-color: #40a9ff;
          border-right-width: 1px !important;
        }

        // 字体左边间距
        .ant-select-selection__rendered {
          margin-left: 0px;
        }

        // 计数器样式
        .has-error .ant-select-selection {
          border-bottom-color: #f5222d;
        }

        // 激活样式
        .ant-input-number:focus {
          box-shadow: none;
          border-bottom-color: #40a9ff;
        }

        .has-error .ant-input-number-focused {
          box-shadow: none;
          border-bottom-color: #f5222d;
        }

        .ant-input-number-focused {
          box-shadow: none;
          border-bottom-color: #40a9ff;
        }

        .ant-input-number-input,.ant-input {
          padding: 0;
        }
        .ant-input-number,.ant-input {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #c7c7c7;
          border-bottom-color: #c7c7c7 !important;
        }
        .ant-input:focus{
          box-shadow: 0 0 0px rgba(24, 144, 255, 0.2);
          border-bottom-color: #40a9ff !important;
        }
        .ant-input:hover {
          border-bottom-color: #40a9ff !important;
        }
        // 禁用
        .ant-select-disabled .ant-select-selection,.ant-input-disabled {
          background: transparent;
          border-bottom: 1px dashed #c7c7c7;
        }
      }


    }

    .ant-table-thead>tr>th {
      background: #fafafa;
    }
  }
}


.job-details {

  ::v-deep .ant-descriptions-row{
    display: flex;
    width: 100%;

    .ant-descriptions-item-label{
      background-color: #ffff;
      color: #495374;
      font-weight: 600;
      width: 23%;
      display: inline-block;
    }
    .ant-descriptions-item-content{
      width: 77%;
    }
  }

}

::v-deep .ant-table-tbody {
  .ant-form-item {
    margin-bottom: 0px;

    .ant-input {
      border: none;
      border-radius: 0px;
      border-bottom: 1px solid #c7c7c7;
    }
    .ant-input:focus {
      box-shadow: none;
      border-bottom-color: #40a9ff;
    }

    .ant-input {
      padding: 0;
    }

    .has-error .ant-input-focused {
      box-shadow: none;
      border-bottom-color: #f5222d;
    }

    .ant-input-focused {
      box-shadow: none;
      border-bottom-color: #40a9ff;
    }
  }
}
.a-model-class{
  ::v-deep .ant-modal-body{
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    max-height: 400px;
    padding: 0 10px 0 20px;
  }
  .ant-modal-footer{
    padding-top: 0px;
  }
  // 视频播放
  .video-box{
    //padding:0 15px;
    position: relative;
    padding: 5px 15px 0 0;
    p{
      width: 250px;
      background-color: rgba(10, 10, 10, 0.5);
      color: #ffffff;
      position: absolute;
      opacity:1;
    }
    video{
      width: 250px;
      height: 150px;
    }
  }
  .video-box:nth-child(3n){
    padding-right: 0px;
  }
  .video-box:nth-child(n+1):nth-child(-n+3){
    padding-top: 0px;
  }
}
// 切换框
::v-deep .ant-tabs-nav {
  width: 100%;

  .ant-tabs-tab {
    width: 50%;
    text-align: center;
  }

  .ant-tabs-tab:nth-child(1) {
    margin: 0px;
  }

  .ant-tabs-tab-active {
    background-color: #fafafa;
    font-weight: 600;
  }
}
.video_text{
  width: 70%;
  margin: 0 auto;
}
video:focus{
  outline: 0;      //去掉选中蓝框
}
.video-js {
  width: 480px;
  height: 400px;
  .vjs-big-play-button{
    /*对播放按钮的样式进行设置*/
    width: 100px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }
}

.previewPictures{
  position: relative;
   img{
     width: 100%;
     height: 100%;
   }
  .previewPictures-operation{
    top: 0px;
    position: absolute;
    width:  100%;
    height:  100%;
    background-color: rgba(0,0,0,.5);
    content: " ";
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffff;

    i{
      font-size: 25px;
    }
  }
}
.previewPictures:hover{
  .previewPictures-operation{

    opacity: 1;
    transition: all 0.6s;
  }
}

.preview-box{
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  pointer-events: auto;

  .ant-modal-close{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    padding: 0;
    color: rgba(0,0,0,.45);
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    background: transparent;
    border: 0;
    outline: 0;
    cursor: pointer;
    transition: color .3s;
  }
  ::v-deep .ant-modal-body{
    padding: 24px !important;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
  }
}

.details{
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

</style>
